const DEBUG = true;

export function log(msg) {
  if (DEBUG) {
    console.log(msg);
  }
}
